import SimpleDropdown, {
  SimpleDropdownLabel,
} from "../forms/general/SimpleDropdown";

interface SortDropdownProps {
  selectedSort: string;
  onSortChange: (sort: string) => void;
  theme?: string;
}

const SortDropdown: React.FC<SortDropdownProps> = ({
  selectedSort,
  onSortChange,
  theme,
}) => {
  const sortOptions = [
    { id: "desc", name: "Most Recent" },
    { id: "asc", name: "Oldest" },
  ];

  return (
    <div className="relative ml-4 w-36">
      <SimpleDropdown
        options={sortOptions}
        label={SimpleDropdownLabel.Sort}
        onChange={(selected) => onSortChange(selected)}
        value={selectedSort}
        theme={theme}
      />
    </div>
  );
};

export default SortDropdown;
